import React, {useState} from "react";
import useEditableTableTextAreaCell from "../../hooks/useEditableTableTextAreaCell";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";
import useEditableTableTextCell from "../../hooks/useEditableTableTextCell";
import useEditableTableDateCell from "../../hooks/useEditableTableDateCell";
import useEditableTableCostCell from "../../hooks/useEditableTableCostCell";
import {Button} from "react-bulma-components";
import FAIcon from "../Icon/FAIcon";

export default function WorkCreditRow({data, onChange, onSave, onDelete, onReady, onApprove, index, nominalCodes, onNominalChange}){
    const [editable, setEditable] = useState(false);

    const handleSave = () => {
        onSave(data);
        setEditable(false);
    }

    return (
        <tr key={data.id}>
            <td>{data.work ? data.work.id : ""}</td>
            <td>{data.work ? data.work.description : ""}</td>
            {useEditableTableTextAreaCell({
                propName: "description",
                value: data.description,
                onSave: handleSave,
                onChange: (e) => onChange(e, index),
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            <td>{data.work ? data.work.customer : ""}</td>
            <td>
                <NominalCodePicker
                    options={nominalCodes}
                    value={data.vat_nominal_code}
                    onChange={(e) => onNominalChange(e, index)}
                    onSave={handleSave}
                    name={"vat_nominal_code"}
                    editable={editable}
                    setEditable={setEditable}
                    blank={true}
                    disabled={data.approved || !editable}
                    inlineEdit={!data.approved}
                />
            </td>
            <td>
                <NominalCodePicker
                    options={nominalCodes}
                    value={data.no_vat_nominal_code}
                    onChange={(e) => onNominalChange(e, index)}
                    onSave={handleSave}
                    name={"no_vat_nominal_code"}
                    editable={editable}
                    setEditable={setEditable}
                    blank={true}
                    disabled={data.approved || !editable}
                    inlineEdit={!data.approved}
                />
            </td>
            {useEditableTableTextCell({
                propName: "credit_note_number",
                value: data.credit_note_number,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {useEditableTableDateCell({
                propName: "date_issued",
                value: data.date_issued,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {useEditableTableCostCell({
                propName: "amount",
                value: data.amount,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {useEditableTableCostCell({
                propName: "no_vat_amount",
                value: data.no_vat_amount,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true,
                disabled: data.approved
            })}
            {!data.ready_to_approve &&
                <td>
                    <Button
                        color={"info"}
                        onClick={() => onReady(data)}
                    >
                        <FAIcon size="small" icon={["fas", "check"]}/>
                    </Button>
                </td>
            }
            {data.ready_to_approve && !data.approved &&
                <td>
                    <Button
                        color={"success"}
                        onClick={() => onApprove(data)}
                    >
                        <FAIcon size="small" icon={["fas", "check"]}/>
                    </Button>
                </td>
            }
            <td>
                <Button
                    color={"danger"}
                    onClick={() => onDelete(data)}
                    disabled={data.approved}
                >
                    X
                </Button>
            </td>
        </tr>
    )



}